// "NOT BILLING THIS MONTH" — a decision, recorded.
//
// Deliberately not a delete and not a dismissal. An uninvoiced month inside a term used
// to be a dashboard notification, and a notification you ignore is noise for a while;
// now it is a ROW on the screen the partners work from daily, and a row that cannot be
// resolved is permanent noise — the one month you agreed not to charge for sits there
// forever until the eye learns to skip the whole list.
//
// So it is marked, not removed. The row stays visible in its own quiet state, with who
// decided and optionally why, and it can be put back. A month that simply vanished would
// be indistinguishable from one everybody forgot, which is the confusion the whole alert
// layer exists to prevent.
//
// It also closes the missing-invoice alert for that period, through the same table the
// alert reads — so the dashboard's nudge and this screen cannot disagree about whether
// the month is still owed.
import { useState } from 'react';
import { collectionsApi } from '../../api';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import { Textarea } from '../../components/Form';
import { ErrorText } from '../../components/Loader';

const t = he.collections.board;

export default function SkipMonthModal({ card, month, onClose, onSaved }) {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await collectionsApi.skipMonth(card.id, { period_month: month, reason });
      onSaved();
    } catch (e) {
      setError(e);
      setSaving(false);
    }
  };

  return (
    <Modal
      title={t.skipTitle}
      onClose={onClose}
      onSave={submit}
      saveLabel={t.skipConfirm}
      saveDisabled={saving}
    >
      <p>
        <strong>{card.title}</strong>
        <span className="muted"> · {card.clientName}</span>
        {' · '}{month}
      </p>
      {/* Optional, and it says so. A month is often skipped for a reason nobody needs
          written down, and demanding one would just produce a field full of "-". */}
      <Textarea label={t.skipReason} value={reason} onChange={(e) => setReason(e.target.value)} />
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
